import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { AuthService } from "../auth";
import { HttpClient } from '@angular/common/http';
import * as signalR from '@microsoft/signalr';
import { first } from "rxjs";

@Injectable({ providedIn: 'root' })
export class MessengerHistoryService {
  private hubConnection?: signalR.HubConnection;
  private readonly baseUrl = `${environment.messenger}/hubs/history`;

  private historyCallbacks: ((history: any) => void)[] = [];
  private newItemCallbacks: ((summary: any) => void)[] = [];

  constructor(private authService: AuthService, private http: HttpClient) { }

  public async connect(): Promise<void> {
    if (this.hubConnection?.state === signalR.HubConnectionState.Connected) return;

    let token = environment?.useAuthService ? this.authService.getAccessToken() : null;

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(this.baseUrl, {
        accessTokenFactory: () => token,
      })
      .withAutomaticReconnect()
      .build();

    this.hubConnection.on('ReceiveHistory', (history) => {
      this.historyCallbacks.forEach((cb) => cb(history));
    });

    this.hubConnection.on('ReceiveNewHistoryItem', (summary) => {
      this.newItemCallbacks.forEach((cb) => cb(summary));
    });

    await this.hubConnection.start();
  }

  public async disconnect(): Promise<void> {
    if (this.hubConnection) {
      this.hubConnection.off('ReceiveHistory');
      this.hubConnection.off('ReceiveNewHistoryItem');

      try {
        await this.hubConnection.stop();
      } catch (err) {
        console.warn('[SignalR] Disconnect error:', err);
      }

      this.hubConnection = undefined;
    }

    this.historyCallbacks = [];
    this.newItemCallbacks = [];
  }

  public load(skip = 0, take = 20): void {
    this.hubConnection?.invoke('LoadHistory', skip, take).catch(console.error);
  }

  public onHistory(callback: (history: any) => void): void {
    if (!this.historyCallbacks.includes(callback)) {
      this.historyCallbacks.push(callback);
    }
  }

  public onNewItem(callback: (summary: any) => void): void {
    if (!this.newItemCallbacks.includes(callback)) {
      this.newItemCallbacks.push(callback);
    }
  }

  public markAsRead(id: number): any {
    return this.http.post(`${environment.messenger}/api/MessageThreads/${id}/mark-as-read`, null, { responseType: 'noCredential' as 'json' })
      .pipe(first())
  }
}
